<template>
  <div>
    <slot v-if="required" v-bind="slotData">
      <ValidationProvider :rules="rules" v-slot="{ errors }" slim>
        <div class="form-group"
            :class="[
          {'input-group': hasIcon},
          {'has-danger': error},
          {'focused': focused},
          {'has-label': label || $slots.label},
          {'has-success': valid === true},
          {'has-danger': valid === false}
          ]">
            <slot name="label">
                <label v-if="label" class="form-control-label" style="width: 100%;" :class="labelClasses">
                    {{label}}
                    <!-- <span v-if="required">*</span> -->
                    <span style="color:red" v-if="required">*</span>
                </label>
            </slot>
            <div v-if="addonLeftIcon || $slots.addonLeft" class="input-group-prepend">
              <span class="input-group-text">
                <slot name="addonLeft">
                  <i :class="addonLeftIcon"></i>
                </slot>
              </span>
            </div>
            <input
                    :value="value"
                    v-if="!passwordHidden"
                    :name="name"
                    v-on="listeners"
                    v-bind="$attrs"
                    type="text"
                    class="form-control"
                    :class="[
                     {'is-valid': valid === true},
                     {'is-invalid': valid === false}, inputClasses]"
                    aria-describedby="addon-right addon-left">
            <input
                    v-if="passwordHidden"
                    :value="value"
                    :name="name"
                    v-on="listeners"
                    v-bind="$attrs"
                    :type="type"
                    class="form-control"
                    :class="[
                     {'is-valid': valid === true},
                     {'is-invalid': valid === false}, inputClasses]"
                    aria-describedby="addon-right addon-left">
            <div v-if="addonRightIcon || $slots.addonRight" class="input-group-append">
              <span v-if="addonRightIcon === 'display-eye fa fa-eye'" class="input-group-text">
                  <slot name="addonRight">
                      <i v-if="addonRightIconText === 'display-eye fa fa-eye'" @click="showPassword" :class="addonRightIconText"></i>
                      <i v-if="addonRightIconText === 'display-eye fa fa-eye-slash'" @click="hidePassword" :class="addonRightIconText"></i>
                  </slot>
              </span>
              <span v-if="addonRightIcon !== 'display-eye fa fa-eye'" class="input-group-text">
                  <slot name="addonRight">
                      <i v-if="addonRightIcon" :class="addonRightIcon"></i>
                  </slot>
              </span>
            </div>
            <slot name="infoBlock"></slot>
            <slot name="helpBlock">
                <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="errors">
                    {{ errors[0] }}
                </div>
            </slot>
        </div>
      </ValidationProvider>
    </slot>
    <slot v-if="!required" v-bind="slotData">
        <div class="form-group"
            :class="[
          {'input-group': hasIcon},
          {'has-danger': error},
          {'focused': focused},
          {'has-label': label || $slots.label},
          {'has-success': valid === true},
          {'has-danger': valid === false}
          ]">
            <slot name="label">
                <label v-if="label" class="form-control-label" :class="labelClasses">
                    {{label}}
                    <!-- <span v-if="required">*</span> -->
                </label>
            </slot>
            <div v-if="addonLeftIcon || $slots.addonLeft" class="input-group-prepend">
              <span class="input-group-text">
                <slot name="addonLeft">
                  <i :class="addonLeftIcon"></i>
                </slot>
              </span>
            </div>
            <input
                    :value="value"
                    :name="name"
                    v-on="listeners"
                    v-bind="$attrs"
                    class="form-control"
                    :class="[
                     {'is-valid': valid === true},
                     {'is-invalid': valid === false}, inputClasses]"
                    aria-describedby="addon-right addon-left">
            <div v-if="addonRightIcon || $slots.addonRight" class="input-group-append">
              <span class="input-group-text">
                  <slot name="addonRight">
                      <i :class="addonRightIcon"></i>
                  </slot>
              </span>
            </div>
            <slot name="infoBlock"></slot>
            <slot name="helpBlock">
                <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
                    {{ error }}
                </div>
            </slot>
        </div>
    </slot>
  </div>
</template>
<script>
import i18n from "@/i18n"
import { ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules';
extend('email', {
  ...email,
  message: i18n.t('email_only')
});
extend('required', {
  ...required,
  message: i18n.t('required')+' {_field_}'
});
extend('min', {
  validate(value, args) {
    return value.length >= args.length
  },
  params: ['length'],
  message: '{_field_} ' +i18n.t('required_min')+ ' {length} ' +i18n.t('required_min_2')
})
export default {
  inheritAttrs: false,
  name: "base-input",
  props: {
    type: {
      type: String,
      description: "type"
    },
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    rules: {
      type: String,
      description: "input rules",
      default: ""
    },
    name: {
      type: String,
      description: "input name"
    },
    valid: {
      type: Boolean,
      description: "Whether is valid",
      default: undefined
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    error: {
      type: String,
      description: "Input error (below input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    inputClasses: {
      type: String,
      description: "Input css classes"
    },
    value: {
      type: [String, Number],
      description: "Input value"
    },
    addonRightIcon: {
      type: String,
      description: "Addon right icon"
    },
    addonLeftIcon: {
      type: String,
      description: "Addont left icon"
    }
  },
  data() {
    return {
      focused: false,
      passwordHidden: {
        default: true,
        type: Boolean
      },
      addonRightIconText: "display-eye fa fa-eye"
    };
  },
  components: {
    ValidationProvider
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    }
  },
  methods: {
    showPassword() {
      this.passwordHidden = false;
      this.addonRightIconText = "display-eye fa fa-eye-slash";
    },
    hidePassword() {
      this.passwordHidden = true;
      this.addonRightIconText = "display-eye fa fa-eye";
    },
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    }
  }
};
</script>
<style>
</style>
